import { render, staticRenderFns } from "./ConsentPrint.vue?vue&type=template&id=06a04807&scoped=true&"
import script from "./ConsentPrint.vue?vue&type=script&lang=js&"
export * from "./ConsentPrint.vue?vue&type=script&lang=js&"
import style0 from "./ConsentPrint.vue?vue&type=style&index=0&id=06a04807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a04807",
  null
  
)

export default component.exports